import config from 'react-global-configuration';
import CoreWebformComponent from '@uncinc/react-drupal-core/dist/Components/Webform';

// @ts-expect-error
class WebformComponent extends CoreWebformComponent.WrappedComponent {
  /**
   * Overwrite the submit function so we can change the api url & enable cors.
   *
   * @param {Record<string, string>} values
   *   The values to submit.
   * @param {boolean} handleResponse
   *   Boolean indicating if we should have the response, e.g. display a message.
   *   Useful for auto-submission purposes.
   * @returns {void}
   */
  async submit(values, handleResponse = true) {
    const { id, language, onSubmit } = this.props;
    const API_URL = config.get('WEBFORM_API_URL');
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    // Replace the 'other' options with the actual value.
    Object.keys(values).forEach((key) => {
      if (values[key] === '__other__') {
        // eslint-disable-next-line no-param-reassign
        values[key] = values[`${key}--other`];
      }
    });

    if (typeof onSubmit === 'function') {
      onSubmit(values);
    }

    await fetch(`${PATH}/session/token`, { credentials: 'include' })
      .then((response) => response.text())
      .then((csrfToken) => {
        fetch(`${PATH}/webform_rest/submit`, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({
            webform_id: id,
            ...values,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        }).then((response) => response.json())
          .then((response) => {
            if (response.error) {
              this.handleFailedSubmit(response.error);
            } else if (handleResponse) {
              this.handleSuccessfulSubmit(response);
            }
          })
          .catch((e) => {
            this.handleFailedSubmit(e);
          });
      })
      .catch((e) => {
        this.handleFailedSubmit(e);
      });
  }
}

export default WebformComponent;
